// src/routes/routesConfig.js
// import HomePage from "pages/HomePage";
import NotFoundPage from "pages/NotFoundPage";
import AwardsPresentation from "pages/AwardsPresentation/AwardsPresentation";
import AwardResultsPage from "pages/AwardResultsPage";
// import AboutPage from './Nope/Page';
// import NotFoundPage from './components/NotFoundPage';

const routesConfig = [
  { path: "/", element: AwardResultsPage, exact: true },
  { path: "/ap", element: AwardsPresentation, exact: true },
  { path: "/results", element: AwardResultsPage, exact: true },
  { path: "*", element: NotFoundPage },
];

export default routesConfig;
